import {
  CurrentSubView,
  RetorikEvent,
  setCurrentCustomView,
  useUtilsStore
} from '@davi-ai/retorik-framework'
import React, { useEffect /*, useState */ } from 'react'
// import ReactDOM from 'react-dom/client'
import { useDispatch, useSelector } from 'react-redux'
// import { setDetailOpennedByMap } from '../features/poiSlice'
import type { RootState } from '../stores/globalStore'
import '../styles/components/BotPOIExtensionDisplay.scss'
import MapIcon from '../styles/icons/location'
import {
  setDetailOpennedByMap,
  setDisplayPOIFinished
} from '../features/poiSlice'
import { toggleLoader } from '../features/mapSlice'
const BotPOIExtensionDisplay = (): JSX.Element => {
  const dispatch = useDispatch()
  const retorikEvent = useUtilsStore((state) => state.retorikEvent)
  const currentSubView = useUtilsStore((state) => state.currentSubView)
  /* const selectedPOI: string = useSelector(
    (state: RootState) => state.map.selectedPOIIdentifier
  ) */
  const displayPOIFinished = useSelector(
    (state: RootState) => state.poi.displayPOIFinished
  )
  const detailOpennedByMap = useSelector(
    (state: RootState) => state.poi.detailOpennedByMap
  )
  // const [show, setShow] = useState<boolean>(true)

  /* const onClick = (): any => {
    console.log('CLIC', selectedPOI)

    setShow(false)
    // dispatch(setDetailOpennedByMap({ detailOpennedByMap: false }))
    setCurrentCustomView({
      clickHandler: (): void => console.log('Test'),
      customDisplay: 'mapDisplay',
      label: { 'fr-FR': 'Carte Interactive', 'en-US': 'Interactive map' },
      icon: <MapIcon />,
      indice: 1
    })
  } */

  /* useEffect(() => {
    console.log(
      displayPOIFinished,
      selectedPOI,
      'displayPOIFinished, selectedPOI'
    )
    if (selectedPOI) {
      const element = (
        <>
          {selectedPOI !== '' && show && (
            <div className='buttonPOI' onClick={onClick}>
              Voir sur la carte
            </div>
          )}
        </>
      )
      setTimeout(() => {
        const host = document.querySelector('#retorik-shadow')
        const container = document.createElement('div')
        container.id = 'POIButtonContainer'
        if (
          host &&
          host.shadowRoot &&
          host.shadowRoot.querySelector('.leaflet-container:not(#mapid)') !==
            null
        ) {
          const host = document.querySelector('#retorik-shadow')
          if (host && host.shadowRoot) {
            const leaflet = host.shadowRoot.querySelector(
              '.leaflet-container:not(#mapid)'
            )
            if (leaflet) leaflet.append(container)
            const containerPOI = host.shadowRoot.querySelector(
              '#POIButtonContainer'
            )
            if (containerPOI) {
              const root = ReactDOM.createRoot(containerPOI)
              root.render(element)
            }
          }
        }
      }, 500)
    }
  }, [displayPOIFinished]) 
  
  useEffect(() => {
    if (selectedPOI !== '') {
      setShow(true)
    }
  }, [selectedPOI]) */

  useEffect(() => {
    console.log(
      'currentSubView, retorikEvent',
      currentSubView,
      retorikEvent,
      displayPOIFinished,
      detailOpennedByMap
    )
    if (
      retorikEvent &&
      retorikEvent === RetorikEvent.DetailViewClose &&
      currentSubView === CurrentSubView.none &&
      displayPOIFinished
    ) {
      // Check if POI detail was openned by MAP
      if (detailOpennedByMap) {
        console.log('Re-Open Map')
        // Re-Open Map

        setCurrentCustomView({
          clickHandler: (): void => console.log('Test'),
          customDisplay: 'mapDisplay',
          label: { 'fr-FR': 'Carte Interactive', 'en-US': 'Interactive map' },
          icon: <MapIcon />,
          indice: 1
        })
        // reset state
        dispatch(setDetailOpennedByMap({ detailOpennedByMap: false }))
        dispatch(setDisplayPOIFinished({ displayPOIFinished: false }))
      }
    } else if (retorikEvent && retorikEvent === RetorikEvent.DetailViewOpen) {
      dispatch(
        setDisplayPOIFinished({
          displayPOIFinished: true
        })
      )
      dispatch(
        toggleLoader({
          loading: false
        })
      )
    }
  }, [retorikEvent])

  return <></>
}

export { BotPOIExtensionDisplay }
